import { wizardAdvisorsMetricsApi, wizardAdvosorsMetricsKeys } from '@client/api/waterlily';
import { useQuery } from '@tanstack/react-query';

export function useAdvisorMetricsApi(enabled: boolean = false) {
  return useQuery({
    queryKey: wizardAdvosorsMetricsKeys.all,
    queryFn: wizardAdvisorsMetricsApi.getMetrics,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled,
  });
}
